function roundToPrecision(value: number, precision: number = 2): number {
  const factor = Math.pow(10, precision);
  return Math.round(value * factor) / factor;
}

export function parseEventScore(event: string, result: string): number {
  const trimmed = result.trim();

  // Handle numeric result events
  if (["bench", "squat", "shots"].includes(event)) {
    const parsed = parseFloat(trimmed);
    return isNaN(parsed) ? NaN : roundToPrecision(parsed);
  }

  // Handle MM:SS.SS or MM:SS
  const timeParts = trimmed.split(":");

  if (timeParts.length === 2) {
    const minutes = parseInt(timeParts[0]);
    const seconds = parseFloat(timeParts[1]);
    if (!isNaN(minutes) && !isNaN(seconds)) {
      return roundToPrecision(minutes * 60 + seconds);
    }
  }

  // Handle plain seconds like "5.26" or "45.00"
  const rawSeconds = parseFloat(trimmed);
  if (!isNaN(rawSeconds)) {
    return roundToPrecision(rawSeconds);
  }

  return NaN; // Fallback if nothing matches
}

export function formatEventScore(event: string, score: number): string {
  if (typeof score !== "number" || isNaN(score)) {
    return "–";
  }

  if (["bench", "squat", "shots"].includes(event)) {
    return roundToPrecision(score).toString();
  }

  if (["swim", "run"].includes(event)) {
    if (score < 60) {
      return roundToPrecision(score, 2).toFixed(2);
    } else {
      const minutes = Math.floor(score / 60);
      const seconds = roundToPrecision(score % 60)
        .toFixed(2)
        .padStart(5, "0");
      return `${minutes}:${seconds}`;
    }
  }

  return roundToPrecision(score).toString();
}
